import React from 'react';
import { BreakpointsInPx } from '../../../constants/breakpoints.constants';
import useMediaQuery from '../../../lib/custom-hooks/useMediaQuery';
import { googleClickCtaEvent } from '../../../utils/analytics';
import { targetLinkdsk } from '../../../utils/targetDskLink';
import CTAButton, { ctaEnums } from '../../@shared/ctaButton';
import Icon from '../../@shared/icon';
import RoutableNotEditableLink from '../../@shared/routableNotEditableLink';
import { ProductSeriesDetailTestimonialModel } from '../models/productSeriesDetailTestimonial.model';

const TestimonialButtons = ({ model }: { model: ProductSeriesDetailTestimonialModel }) => {
  const isDesktop = useMediaQuery(`(min-width: ${BreakpointsInPx['md']})`);

  const clickCTAEvent = (action: string | undefined) => {
    googleClickCtaEvent('Button', action, model?.title?.value ?? model?.eyebrow?.value ?? '');
  };

  return (
    <div className="product-series-testimonial__buttons">
      {model.button1 && model.button1?.label && (
        <CTAButton type={ctaEnums.primaryRed}>
          <RoutableNotEditableLink
            className="product-series-testimonial__buttons--primary"
            href={model.button1Link}
            target={targetLinkdsk({ value: { href: model?.button1?.url, target: model?.button1?.target } }, isDesktop)}
            onClick={() => clickCTAEvent(model?.button1?.label)}
          >
            {model.button1.label}
          </RoutableNotEditableLink>
        </CTAButton>
      )}
      {model.button2 && model.button2?.label && (
        <span className="product-series-testimonial__buttons--secondary">
          <RoutableNotEditableLink
            href={model.button2Link}
            target={targetLinkdsk({ value: { href: model?.button2?.url, target: model?.button2?.target } }, isDesktop)}
            onClick={() => clickCTAEvent(model?.button2?.label)}
          >
            {model.button2.label}
          </RoutableNotEditableLink>
          <Icon iconName="arrow-simple-right" size={24} color="primary" extraClassName="cta-with-arrow__icon" />
        </span>
      )}
    </div>
  );
};

export default TestimonialButtons;
